module.exports = __webpack_public_path__ + "img/logo.68ca49a8.png";